import { call, put } from "redux-saga/effects";
import { AxiosError, AxiosResponse } from "axios";

// Response / Request
import { Result } from "@models/common/resultResponse";
import { KeyValue } from "@/main/models/common";

// Redux
import { GetCountriesPublic, GetCountriesUser, saveCountriesPublic, saveCountriesUser } from "./index";

// Api's
import { countryApi } from "../../api";
import { errorBoundaryReduxSaga, renderErrorReduxSaga } from "@/main/services/utils";
import { CountryPublicResponse } from "@/main/models/response";

export function* getCountriesUserSaga(action: GetCountriesUser) {
	try {
		const response: AxiosResponse<Result<KeyValue[]>> = yield call(countryApi.getDomain, action.payload.idUser);
		if (response.data.result) {
			yield put(saveCountriesUser(response.data.result, false, null));
		}
	} catch (exception) {
		if (exception instanceof AxiosError) {
			const resultError = errorBoundaryReduxSaga(exception);
			renderErrorReduxSaga(resultError);

			yield put(saveCountriesUser(null, true, resultError.messagesDataError));
		}
	}
}

export function* getCountriesPublicSaga(_action: GetCountriesPublic) {
	try {
		const response: AxiosResponse<Result<CountryPublicResponse[]>> = yield call(countryApi.getPublicDomain);
		if (response.data.result) {
			yield put(saveCountriesPublic(response.data.result, false, null));
		}
	} catch (exception) {
		if (exception instanceof AxiosError) {
			const resultError = errorBoundaryReduxSaga(exception);
			renderErrorReduxSaga(resultError);

			yield put(saveCountriesPublic(null, true, resultError.messagesDataError));
		}
	}
}
